/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import ReferralModal from "./ReferralModal";
import trackEvent from "../../shared/ga/trackEvent";
import { Wrapper, Text, Icon } from "./styles/referral-styles";

class Referral extends Component {
  state = {
    modalActive: false,
  };

  toggleModal = () => {
    this.setState(({ modalActive }) => {
      if (!modalActive) {
        trackEvent("Navigation", "Refer a Friend", "Button Click");
      }
      return {
        modalActive: !modalActive,
      };
    });
  };

  render() {
    const { modalActive } = this.state;
    const { user } = this.props;
    const { firstName, userId } = user;

    return (
      <Fragment>
        {modalActive && (
          <ReferralModal
            toggleModal={this.toggleModal}
            firstName={firstName}
            userId={userId}
          />
        )}
        <Wrapper
          onClick={this.toggleModal}
          data-test-id="refer-a-friend"
          data-tip="Refer a friend"
          data-for="refer-a-friend-tooltip"
          data-offset="{ 'top': 15 }"
        >
          <ReactTooltip
            place="bottom"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="refer-a-friend-tooltip"
          />
          <Text>Refer a friend</Text>
          <Icon>
            <FontAwesomeIcon icon={faGift} />
          </Icon>
        </Wrapper>
      </Fragment>
    );
  }
}

Referral.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    userId: PropTypes.number,
  }).isRequired,
};

export default Referral;
